import { FC, createContext, useContext, useRef, useState } from 'react';
import { TUseFieldValidationReturn } from './useFieldValidation';
import { TValidationMode } from './types';

export type TUploadedProductStatus = { dataId: string; productId?: string; error?: string };

export type TValidationContextValue = {
  fieldsRef: React.MutableRefObject<Record<string, TUseFieldValidationReturn>>;
  globalMode: TValidationMode;
  setGlobalMode: React.Dispatch<React.SetStateAction<TValidationMode>>;
  debounceMs: number;
  setDebounceMs: React.Dispatch<React.SetStateAction<number>>;
};

export const contextDefaultValue: TValidationContextValue = {
  fieldsRef: { current: {} },
  globalMode: 'blur',
  setGlobalMode: () => {},
  debounceMs: 250,
  setDebounceMs: () => {},
};

export const ValidationContext = createContext<TValidationContextValue>(contextDefaultValue);

export const ValidationProvider: FC = ({ children }) => {
  const fieldsRef = useRef<Record<string, TUseFieldValidationReturn>>({});
  const [globalMode, setGlobalMode] = useState<TValidationMode>('blur');
  const [debounceMs, setDebounceMs] = useState(250);

  return (
    <ValidationContext.Provider value={{ fieldsRef, globalMode, setGlobalMode, debounceMs, setDebounceMs }}>
      {children}
    </ValidationContext.Provider>
  );
};

export const useValidationContext = () => {
  return useContext(ValidationContext);
};
